import React, { useCallback } from "react";

import {
  UIProvider as _UIProvider,
  UIProviderProps as _UIProviderProps,
} from "@bared/ui";

import { useSite } from "~/hooks/useSite";
import { useSanityClient } from "~/hooks/sanity";
import { useGoogleTagManager } from "~/hooks/useGoogleTagManager";

import { Link } from "~/components/Link";
import { useSessionLoggedIn } from "@hooks/useSession";

export interface UIProviderProps {
  children: React.ReactNode;
}

export function UIProvider({ children }: UIProviderProps) {
  const site = useSite();
  const googleTagManager = useGoogleTagManager();
  const loggedIn = useSessionLoggedIn();

  /** Handle tracking events emitted by the UI lib. */
  const onEvent = useCallback<NonNullable<_UIProviderProps["onEvent"]>>(
    (event) => {
      googleTagManager.push(event);
    },
    [googleTagManager],
  );

  /** Sanity client resolved from context. */
  const sanityClient = useSanityClient();

  return (
    <_UIProvider
      onEvent={onEvent}
      locale={site.locale}
      countryCode={site.countryCode}
      sanityClient={sanityClient}
      isLoggedIn={loggedIn}
      renderLink={(props) => <Link {...props} href={props.href ?? undefined} />}
    >
      {children}
    </_UIProvider>
  );
}

UIProvider.displayName = "UIProvider";
